
export const visibleForLocale = (items, currentLocale) => {
    return items.filter(item => {
        return !item.visibleWhen || item.visibleWhen === currentLocale;
    });
};
